import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Products } from "./components/products";
import { Contact } from "./components/contact";
import { ContactForm } from "./components/contact-form";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation data={landingPageData.Contact} />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Products data={landingPageData.Products} />
      <Contact data={landingPageData.Contact} />
      <ContactForm />
    </div>
  );
};

export default App;
